<app-aggregated-amount-item
  name="Twitterキーワード"
  icon="./assets/twitter_search.png"
  amount="{{ (twitterKeywordsCountModel$ | async)?.units }}"
  [hasAmount]="(twitterKeywordsCountModel$ | async)?.hasUnits"
  unit="推定投稿数"
  [rate]="(twitterKeywordsCountModel$ | async)?.rate"
  link=""
  help="Brandwatchの Twitterキーワード投稿数です。選択期間内に投稿された次のキーワードを含む投稿数の合計です。【{{
    (twitterKeywordsCountModel$ | async)?.containWords
  }}】"
  [loading]="loading$ | async"
  [dataCollections]="dataCollections$ | async"
  [dataCollectLoading]="dataCollectLoading$ | async"
></app-aggregated-amount-item>
